import React from 'react';
import './unauth-menu-dropdown.styles.scss';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBolt, faBoltLightning, faHome, faMoneyBill, faPlay, faRocket } from '@fortawesome/free-solid-svg-icons';

const UnauthMenuDropdown = ({
    show
}) => {

    const userProfile = useSelector(state => state.userData.userProfile);
    const screenSize = useSelector(state => state.contentData.screenSize);

    return (
        <div className={`${show ? 'active' : ''} unauth-menu-dropdown ${screenSize} ${userProfile && userProfile.upload ? 'upload-user' : ''}`}>
            <div className="dropdown-menu">
                <Link to='/' className='head-link'>
                    <FontAwesomeIcon icon={faHome} />
                    Home
                </Link>
                <Link to="https://gamably.com#features" className='head-link'>
                    <FontAwesomeIcon icon={faRocket} />
                    Features
                </Link>
                <Link to="/pricing" className='head-link'>
                    <FontAwesomeIcon icon={faMoneyBill} />
                    Pricing
                </Link>
                <Link to="/preview" className='head-link'>
                    <FontAwesomeIcon icon={faBoltLightning} />
                    Give it a Try!
                </Link>
            </div>
        </div>
    )
}

export default UnauthMenuDropdown